<template>
  <div style="width: 90%" class="cookie-container-warning">
    <CCard v-if="visible">
      <CCardBody>
        <div class="text-right">
          <span @click="closeClick()">
            <CIcon name="cross" size="custom-size" style="cursor: pointer" :height="12" viewBox="0 0 32 32" />
          </span>
        </div>
        <div class="mt-2">
          {{ $t('home.messages.mobile-message') }}
        </div>
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
export default {
  name: 'MobileWarning',
  data() {
    return {
      visible: true,
    }
  },
  methods: {
    closeClick() {
      this.visible = false
    },
  },
}
</script>
<style>
.cookie-container-warning {
  position: fixed;
  top: 12%;
  z-index: 1001;
}
</style>
